(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["faq"] && !Shopify.designMode) return;
  try {
    
(function() {
  document.querySelectorAll('.gruns-faq-item__question').forEach(function(btn) {
    btn.addEventListener('click', function() {
      var expanded = btn.getAttribute('aria-expanded') === 'true';
      var answerId = btn.getAttribute('aria-controls');
      var answer = document.getElementById(answerId);
      btn.setAttribute('aria-expanded', !expanded);
      if (expanded) {
        answer.setAttribute('hidden', '');
      } else {
        answer.removeAttribute('hidden');
      }
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gruns-hero-2"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('click', function (e) {
  var btn = e.target.closest('.gruns-hero2__cta');
  if (!btn || (btn.getAttribute('href') || '') !== '#pumpy-product') return;
  var target = document.getElementById('pumpy-product')
            || document.querySelector('.gruns-product-wrapper');
  if (!target) return;
  e.preventDefault();
  var top = target.getBoundingClientRect().top + window.pageYOffset
          + (target.offsetHeight / 2) - (window.innerHeight / 2);
  window.scrollTo({ top: Math.max(0, top), behavior: 'smooth' });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gruns-hero"] && !Shopify.designMode) return;
  try {
    
/* Délégation sur document : survit aux re-rendus de section (éditeur Shopify)
   → le bouton fonctionne à chaque clic, pas seulement au premier. */
document.addEventListener('click', function (e) {
  var btn = e.target.closest('.gruns-hero__cta');
  if (!btn || (btn.getAttribute('href') || '') !== '#pumpy-product') return;
  /* On vise l'ancre, sinon repli sur la section produit par sa classe */
  var target = document.getElementById('pumpy-product')
            || document.querySelector('.gruns-product-wrapper');
  if (!target) return; /* cible absente → on ne casse rien */
  e.preventDefault();
  /* On centre le MILIEU de la section produit dans la fenêtre */
  var top = target.getBoundingClientRect().top + window.pageYOffset
          + (target.offsetHeight / 2) - (window.innerHeight / 2);
  window.scrollTo({ top: Math.max(0, top), behavior: 'smooth' });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gruns-social-videos"] && !Shopify.designMode) return;
  try {
    
(function() {
  var MUTED_SVG = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><polygon points="11 5 6 9 2 9 2 15 6 15 11 19 11 5"/><line x1="23" y1="9" x2="17" y2="15"/><line x1="17" y1="9" x2="23" y2="15"/></svg>';
  var SOUND_SVG = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><polygon points="11 5 6 9 2 9 2 15 6 15 11 19 11 5"/><path d="M19.07 4.93a10 10 0 010 14.14M15.54 8.46a5 5 0 010 7.07"/></svg>';

  document.querySelectorAll('.gruns-social-videos__wrap').forEach(function(wrap) {

    /* ─── Setup a single video card ─── */
    function setupCard(card) {
      if (card._ready) return;
      card._ready = true;

      var video       = card.querySelector('video');
      var muteBtn     = card.querySelector('.gruns-video-card__mute');
      var progressFill = card.querySelector('.gruns-video-card__progress-fill');

      /* Inject mute icon — sound ON by default */
      if (muteBtn) muteBtn.innerHTML = SOUND_SVG;

      if (!video) return;
      video.muted = false; /* sound ON by default */

      /* Progress bar update */
      function updateProgress() {
        if (!progressFill || !video.duration) return;
        progressFill.style.width = ((video.currentTime / video.duration) * 100) + '%';
      }
      video.addEventListener('timeupdate', updateProgress);
      video.addEventListener('ended', function() {
        card.classList.remove('is-playing');
        if (progressFill) progressFill.style.width = '0%';
      });

      /* Click = play/pause */
      card.addEventListener('click', function(e) {
        if (muteBtn && muteBtn.contains(e.target)) return;
        /* Pause all others */
        wrap.querySelectorAll('.gruns-video-card').forEach(function(c2) {
          if (c2 === card) return;
          var v2 = c2.querySelector('video');
          if (v2) { v2.pause(); }
          c2.classList.remove('is-playing');
          var pf2 = c2.querySelector('.gruns-video-card__progress-fill');
          if (pf2) pf2.style.width = '0%';
        });
        if (video.paused) {
          video.play().catch(function() {});
          card.classList.add('is-playing');
        } else {
          video.pause();
          card.classList.remove('is-playing');
        }
      });

      /* Mute toggle */
      if (muteBtn) {
        muteBtn.addEventListener('click', function(e) {
          e.stopPropagation();
          video.muted = !video.muted;
          muteBtn.innerHTML = video.muted ? MUTED_SVG : SOUND_SVG;
        });
      }
    }

    /* Setup all cards */
    wrap.querySelectorAll('.gruns-video-card').forEach(setupCard);

    /* ─── Mobile carousel ─── */
    var cTrack  = wrap.querySelector('.gruns-social-videos__carousel-track');
    var prevBtn = wrap.querySelector('.gruns-nav-prev');
    var nextBtn = wrap.querySelector('.gruns-nav-next');
    var dots    = Array.from(wrap.querySelectorAll('.gruns-social-videos__dot'));

    if (!cTrack) return;
    var mCards = Array.from(cTrack.querySelectorAll('.gruns-video-card'));
    var cur = 0;

    /* ── Position arrows centered on the visible card ── */
    function positionArrows() {
      if (!prevBtn || !nextBtn || !mCards[0]) return;
      var card    = mCards[cur] || mCards[0];
      var carH    = card.offsetHeight;
      var carTop  = card.offsetTop;
      var mid     = carTop + carH / 2;
      prevBtn.style.top = mid + 'px';
      nextBtn.style.top = mid + 'px';
      /* Horizontal: align with card edges */
      var trackPad = parseFloat(getComputedStyle(cTrack).paddingLeft) || 48;
      prevBtn.style.left = (trackPad - 17) + 'px';
      nextBtn.style.left = (trackPad + card.offsetWidth - 17) + 'px';
    }

    function updateUI() {
      dots.forEach(function(d, j) { d.classList.toggle('is-active', j === cur); });
      /* Loop: always show both arrows */
      if (prevBtn) prevBtn.classList.remove('is-hidden');
      if (nextBtn) nextBtn.classList.remove('is-hidden');
      positionArrows();
    }

    function goTo(idx) {
      /* Loop around */
      if (idx < 0) idx = mCards.length - 1;
      if (idx >= mCards.length) idx = 0;
      cur = idx;
      var card = mCards[cur];
      var padLeft = parseFloat(getComputedStyle(cTrack).paddingLeft) || 48;
      cTrack.scrollTo({ left: card.offsetLeft - padLeft, behavior: 'smooth' });
      updateUI();
    }

    if (prevBtn) prevBtn.addEventListener('click', function(e) { e.stopPropagation(); goTo(cur - 1); });
    if (nextBtn) nextBtn.addEventListener('click', function(e) { e.stopPropagation(); goTo(cur + 1); });
    dots.forEach(function(d, i) { d.addEventListener('click', function() { goTo(i); }); });

    /* Observer: update cur on manual swipe */
    var io = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          var idx = mCards.indexOf(entry.target);
          if (idx !== -1) { cur = idx; updateUI(); }
        }
      });
    }, { root: cTrack, threshold: 0.55 });
    mCards.forEach(function(card) { io.observe(card); });

    /* Initial position after layout */
    setTimeout(function() { updateUI(); }, 100);
    window.addEventListener('resize', positionArrows);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["press-quotes"] && !Shopify.designMode) return;
  try {
    
(function() {
  document.querySelectorAll('.gruns-press').forEach(function(section) {
    var id = section.querySelector('.gruns-press__track').id.replace('press-track-', '');
    var track = document.getElementById('press-track-' + id);
    var slides = track ? track.querySelectorAll('.gruns-press__slide') : [];
    if (!track || slides.length <= 1) return;
    var current = 0;
    function goTo(n) {
      current = (n + slides.length) % slides.length;
      track.style.transform = 'translateX(-' + (current * 100) + '%)';
    }
    var prev = document.getElementById('press-prev-' + id);
    var next = document.getElementById('press-next-' + id);
    if (prev) prev.addEventListener('click', function() { goTo(current - 1); });
    if (next) next.addEventListener('click', function() { goTo(current + 1); });
    setInterval(function() { goTo(current + 1); }, 5000);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pumpy-faq"] && !Shopify.designMode) return;
  try {
    
(function() {
  document.querySelectorAll('.pumpy-faq-item__question').forEach(function(btn) {
    btn.addEventListener('click', function() {
      var expanded = btn.getAttribute('aria-expanded') === 'true';
      var answerId = btn.getAttribute('aria-controls');
      var answer = document.getElementById(answerId);
      btn.setAttribute('aria-expanded', !expanded);
      if (expanded) {
        answer.setAttribute('hidden', '');
      } else {
        answer.removeAttribute('hidden');
      }
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pumpy-hero-2"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('click', function (e) {
  var btn = e.target.closest('.gruns-hero2__cta');
  if (!btn || (btn.getAttribute('href') || '') !== '#pumpy-product') return;
  var target = document.getElementById('pumpy-product')
            || document.querySelector('.pumpy-product-wrapper')
            || document.querySelector('.gruns-product-wrapper');
  if (!target) return;
  e.preventDefault();
  var top = target.getBoundingClientRect().top + window.pageYOffset
          + (target.offsetHeight / 2) - (window.innerHeight / 2);
  window.scrollTo({ top: Math.max(0, top), behavior: 'smooth' });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pumpy-product"] && !Shopify.designMode) return;
  try {
    
(function() {
  /* Gallery */
  document.querySelectorAll('.pumpy-product__gallery').forEach(function(gallery) {
    var mainImg = gallery.querySelector('.pumpy-product__main-img');
    gallery.querySelectorAll('.pumpy-product__thumb').forEach(function(thumb) {
      thumb.addEventListener('click', function() {
        var src = thumb.dataset.src;
        var srcset = thumb.dataset.srcset;
        if (mainImg && src) {
          mainImg.src = src;
          if (srcset) mainImg.srcset = srcset;
        }
        gallery.querySelectorAll('.pumpy-product__thumb').forEach(function(t) {
          t.classList.remove('is-active');
        });
        thumb.classList.add('is-active');
      });
    });
  });

  /* FAQ */
  document.querySelectorAll('.pumpy-product-faq__btn').forEach(function(btn) {
    btn.addEventListener('click', function() {
      var open = btn.getAttribute('aria-expanded') === 'true';
      btn.setAttribute('aria-expanded', String(!open));
      btn.nextElementSibling.classList.toggle('is-open', !open);
    });
  });
})();

(function() {
  /* Variant radio → update hidden input + visual */
  var form = document.querySelector('.gruns-buybox-form');
  if (!form) return;

  var radios = form.querySelectorAll('.gruns-buybox__variant-radio');
  var hiddenId = form.querySelector('input[name="id"]');

  radios.forEach(function(radio) {
    radio.addEventListener('change', function() {
      if (hiddenId) hiddenId.value = radio.value;
      /* update variant-option border */
      form.querySelectorAll('.gruns-buybox__variant-option').forEach(function(opt) {
        opt.classList.toggle('is-selected', opt.contains(radio) && radio.checked);
      });
    });
  });

  /* Qty controls */
  var qtyInput = form.querySelector('.gruns-buybox__qty-input');
  form.querySelectorAll('.gruns-buybox__qty-btn').forEach(function(btn) {
    btn.addEventListener('click', function() {
      var val = parseInt(qtyInput.value) || 1;
      var delta = btn.dataset.delta === '-1' ? -1 : 1;
      qtyInput.value = Math.max(1, val + delta);
    });
  });

  /* Add to cart */
  var cartBtn = form.querySelector('.gruns-buybox__btn--cart');
  if (cartBtn) {
    cartBtn.addEventListener('click', function(e) {
      e.preventDefault();
      var id = hiddenId ? hiddenId.value : null;
      var qty = qtyInput ? parseInt(qtyInput.value) || 1 : 1;
      if (!id) return;
      cartBtn.disabled = true;
      cartBtn.textContent = 'Adding...';
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: id, quantity: qty })
      })
      .then(function(r) { return r.json(); })
      .then(function() {
        cartBtn.textContent = '✓ Added!';
        setTimeout(function() {
          cartBtn.disabled = false;
          cartBtn.textContent = cartBtn.dataset.label || 'Add to cart';
        }, 1800);
      })
      .catch(function() {
        cartBtn.disabled = false;
        cartBtn.textContent = cartBtn.dataset.label || 'Add to cart';
      });
    });
  }

  /* Buy now */
  var buyBtn = form.querySelector('.gruns-buybox__btn--buy');
  if (buyBtn) {
    buyBtn.addEventListener('click', function(e) {
      e.preventDefault();
      var id = hiddenId ? hiddenId.value : null;
      var qty = qtyInput ? parseInt(qtyInput.value) || 1 : 1;
      if (!id) return;
      window.location.href = '/checkout?id=' + id + '&quantity=' + qty;
    });
  }
})();

/* ═══════════════════════════════════════
   PUMPY BUY BOX — onglets + sélection + checkout
═══════════════════════════════════════ */
(function() {
  document.querySelectorAll('.pumpy-bb').forEach(function(root) {
    var mode = 'sub'; // abonnement par défaut
    var tabs = root.querySelectorAll('.pumpy-bb__tab');
    var cards = root.querySelectorAll('.pumpy-bb__card');
    var checkoutBtn = root.querySelector('[data-checkout]');
    var checkoutLabel = root.querySelector('[data-checkout-label]');
    var baseLabel = checkoutLabel ? checkoutLabel.textContent.trim() : 'Commander';

    function selectedCard() {
      var checked = root.querySelector('input[type="radio"]:checked');
      return checked ? checked.closest('.pumpy-bb__card') : null;
    }
    function renderCard(card) {
      var priceSlot = card.querySelector('[data-price-slot]');
      var discBadge = card.querySelector('[data-disc-badge]');
      var strip = card.querySelector('.pumpy-bb__strip');

      /* Prix principal = prix PAR SACHET */
      var per = mode === 'sub' ? card.dataset.subPer : card.dataset.otpPer;
      if (priceSlot) priceSlot.textContent = per;

      var badge = mode === 'sub' ? card.dataset.badgeSub : card.dataset.badgeOtp;
      if (discBadge) {
        if (badge && badge.trim() !== '') {
          discBadge.textContent = badge;
          discBadge.style.display = '';
        } else {
          discBadge.style.display = 'none';
        }
      }

      /* Prix total : affiché uniquement sur la card sélectionnée (packs > 1 sachet) */
      var totalSlot = card.querySelector('[data-total-slot]');
      var input = card.querySelector('input[type="radio"]');
      var isSelected = input && input.checked;
      if (totalSlot) {
        var total = mode === 'sub' ? card.dataset.subPrice : card.dataset.otpPrice;
        if (isSelected && card.dataset.showTotal === '1' && total) {
          var prefix = (root.dataset.totalPrefix || '').trim();
          var suffix = (root.dataset.totalSuffix || '').trim();
          totalSlot.textContent = (prefix ? prefix + ' ' : '') + total + (suffix ? ' ' + suffix : '');
          totalSlot.style.display = '';
        } else {
          totalSlot.style.display = 'none';
        }
      }

      // Bandeau (best-seller / meilleure offre) : abonnement uniquement
      if (strip) strip.style.display = mode === 'sub' ? '' : 'none';

      var subList = card.querySelector('[data-benefits="sub"]');
      var otpList = card.querySelector('[data-benefits="otp"]');
      if (subList) subList.style.display = mode === 'sub' ? '' : 'none';
      if (otpList) otpList.style.display = mode === 'otp' ? '' : 'none';
    }
    function updateCheckout() {
      var card = selectedCard();
      if (!card || !checkoutLabel) return;
      var price = mode === 'sub' ? card.dataset.subPrice : card.dataset.otpPrice;
      checkoutLabel.textContent = baseLabel + '  ·  ' + price;
    }
    function renderAll() {
      cards.forEach(function(card) {
        renderCard(card);
        var input = card.querySelector('input[type="radio"]');
        card.classList.toggle('is-selected', input && input.checked);
      });
      var noteSub = root.querySelector('[data-note-sub]');
      if (noteSub) noteSub.style.display = mode === 'sub' ? '' : 'none';
      updateCheckout();
    }

    tabs.forEach(function(tab) {
      tab.addEventListener('click', function() {
        mode = tab.dataset.mode;
        tabs.forEach(function(t) { t.classList.toggle('is-active', t === tab); });
        renderAll();
      });
    });
    cards.forEach(function(card) {
      var input = card.querySelector('input[type="radio"]');
      card.addEventListener('click', function() {
        if (input) input.checked = true;
        renderAll();
      });
    });
    if (checkoutBtn) {
      checkoutBtn.addEventListener('click', function() {
        var card = selectedCard();
        if (!card) return;
        var body = { id: card.dataset.variant, quantity: 1 };
        if (mode === 'sub' && card.dataset.sellingPlan) {
          body.selling_plan = card.dataset.sellingPlan;
        }
        checkoutBtn.disabled = true;
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(body)
        })
        .then(function() {
          checkoutBtn.disabled = false;
          /* Dawn cart-drawer custom element */
          var drawer = document.querySelector('cart-drawer');
          if (drawer && typeof drawer.open === 'function') {
            drawer.open();
            return;
          }
          /* Bouton panier header Dawn */
          var headerCartBtn = document.querySelector('[aria-controls="cart-drawer"], #cart-icon-bubble, .header__icon--cart');
          if (headerCartBtn) {
            headerCartBtn.click();
            return;
          }
          /* Fallback : premier lien vers /cart */
          var cartLink = document.querySelector('a[href="/cart"]');
          if (cartLink) cartLink.click();
        })
        .catch(function() { checkoutBtn.disabled = false; });
      });
    }

    renderAll();
  });
})();


  } catch(e) { console.error(e); }
})();
})();
